import { render, staticRenderFns } from "./TabHonorarios.vue?vue&type=template&id=601079a7"
import script from "./TabHonorarios.vue?vue&type=script&lang=ts"
export * from "./TabHonorarios.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports